import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import type { UpgradePreviewEffectiveDiscount } from "@/react/types/Paywalls/Checkout/UpgradePreview";

export const UpgradeOrderCouponChip = ({
  discount,
}: {
  discount: UpgradePreviewEffectiveDiscount;
}) => {
  const amount =
    discount.kind === "percent" && discount.percent_off != null
      ? `${Number(discount.percent_off)}%`
      : discount.amount_off?.formatted;
  const description =
    amount && discount.duration
      ? t(["paywall_checkout.coupon_badge", discount.duration], {
          amount,
          count: discount.duration_in_months,
        })
      : undefined;

  return (
    <div
      className="flex w-fit max-w-full items-center gap-3 rounded-lg bg-secondary px-4 py-3"
      data-testid="upgrade-order-coupon-chip"
    >
      <Icon name="tag" size="md" color="secondary" />
      <div className="flex min-w-0 flex-wrap items-baseline gap-x-1">
        <Typography variant="body-sm" component="span">
          {discount.chip_label}
        </Typography>
        {description && (
          <Typography variant="body-sm" component="span" color="secondary">
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
};
